module.exports = __webpack_public_path__ + "static/media/dcs002.5716fb12.png";